// Import all gallery images
import img1 from "../assets/img/gallery/1.jpg";
import img2 from "../assets/img/gallery/2.jpg";
import img3 from "../assets/img/gallery/3.jpg";
import img4 from "../assets/img/gallery/4.jpg";
import img5 from "../assets/img/gallery/5.jpg";
import img6 from "../assets/img/gallery/6.jpg";
import img7 from "../assets/img/gallery/7.jpg";
import img8 from "../assets/img/gallery/8.jpg";
import img9 from "../assets/img/gallery/9.jpg";
import img10 from "../assets/img/gallery/10.jpg";
import img11 from "../assets/img/gallery/11.jpg";
import img12 from "../assets/img/gallery/12.jpg";
import img13 from "../assets/img/gallery/13.jpg";
import img14 from "../assets/img/gallery/14.jpg";
import img15 from "../assets/img/gallery/15.jpg";
import img16 from "../assets/img/gallery/16.jpg";
import img17 from "../assets/img/gallery/17.jpg";
import img18 from "../assets/img/gallery/18.jpg";
import img19 from "../assets/img/gallery/19.jpg";
import img20 from "../assets/img/gallery/20.jpg";
import img21 from "../assets/img/gallery/21.jpg";
import img22 from "../assets/img/gallery/22.jpg";
import img23 from "../assets/img/gallery/23.jpg";
import img24 from "../assets/img/gallery/24.jpg";
import img25 from "../assets/img/gallery/25.jpg";
import img26 from "../assets/img/gallery/26.jpg";
import img27 from "../assets/img/gallery/27.jpg";
import img28 from "../assets/img/gallery/28.jpg";
import img29 from "../assets/img/gallery/29.jpg";
import img30 from "../assets/img/gallery/30.jpg";
import img31 from "../assets/img/gallery/31.jpg";
import img32 from "../assets/img/gallery/32.jpg";
import img33 from "../assets/img/gallery/33.jpg";
import img34 from "../assets/img/gallery/34.jpg";
import img35 from "../assets/img/gallery/35.jpg";
import img36 from "../assets/img/gallery/36.jpg";
import img37 from "../assets/img/gallery/37.jpg";
import img38 from "../assets/img/gallery/38.jpg";
import img39 from "../assets/img/gallery/39.jpg";
import img40 from "../assets/img/gallery/40.jpg";
import img41 from "../assets/img/gallery/41.jpg";
import img42 from "../assets/img/gallery/42.jpg";
import img43 from "../assets/img/gallery/43.jpg";
import img44 from "../assets/img/gallery/44.jpeg";
import img45 from "../assets/img/gallery/45.jpeg";
import img46 from "../assets/img/gallery/46.jpeg";
import img47 from "../assets/img/gallery/47.jpeg";
import img48 from "../assets/img/gallery/48.jpeg";
import img49 from "../assets/img/gallery/49.jpeg";
import img50 from "../assets/img/gallery/50.jpeg";
import img51 from "../assets/img/gallery/51.jpeg";
import img52 from "../assets/img/gallery/52.jpeg";
import img53 from "../assets/img/gallery/53.jpeg";
import img54 from "../assets/img/gallery/54.jpeg";
import img55 from "../assets/img/gallery/55.jpeg";
import img56 from "../assets/img/gallery/56.jpeg";
import img57 from "../assets/img/gallery/57.jpeg";
import img58 from "../assets/img/gallery/58.jpeg";
import img59 from "../assets/img/gallery/59.jpeg";
import img60 from "../assets/img/gallery/60.jpeg";
import img61 from "../assets/img/gallery/61.jpeg";
import img62 from "../assets/img/gallery/62.jpeg";
import img63 from "../assets/img/gallery/63.jpeg";
import img64 from "../assets/img/gallery/64.jpeg";
import img65 from "../assets/img/gallery/65.jpeg";
import img66 from "../assets/img/gallery/66.jpeg";
import img67 from "../assets/img/gallery/67.jpeg";
import img68 from "../assets/img/gallery/68.jpeg";
import img69 from "../assets/img/gallery/69.jpg";
import img70 from "../assets/img/gallery/70.jpg";
import img71 from "../assets/img/gallery/71.jpg";
import img72 from "../assets/img/gallery/72.jpg";
import img73 from "../assets/img/gallery/73.jpg";

const galleryData = [
    { id: 1, image: img1 },
    { id: 2, image: img2 },
    { id: 3, image: img3 },
    { id: 4, image: img4 },
    { id: 5, image: img5 },
    { id: 6, image: img6 },
    { id: 7, image: img7 },
    { id: 8, image: img8 },
    { id: 9, image: img9 },
    { id: 10, image: img10 },
    { id: 11, image: img11 },
    { id: 12, image: img12 },
    { id: 13, image: img13 },
    { id: 14, image: img14 },
    { id: 15, image: img15 },
    { id: 16, image: img16 },
    { id: 17, image: img17 },
    { id: 18, image: img18 },
    { id: 19, image: img19 },
    { id: 20, image: img20 },
    { id: 21, image: img21 },
    { id: 22, image: img22 },
    { id: 23, image: img23 },
    { id: 24, image: img24 },
    { id: 25, image: img25 },
    { id: 26, image: img26 },
    { id: 27, image: img27 },
    { id: 28, image: img28 },
    { id: 29, image: img29 },
    { id: 30, image: img30 },
    { id: 31, image: img31 },
    { id: 32, image: img32 },
    { id: 33, image: img33 },
    { id: 34, image: img34 },
    { id: 35, image: img35 },
    { id: 36, image: img36 },
    { id: 37, image: img37 },
    { id: 38, image: img38 },
    { id: 39, image: img39 },
    { id: 40, image: img40 },
    { id: 41, image: img41 },
    { id: 42, image: img42 },
    { id: 43, image: img43 },
    { id: 44, image: img44 },
    { id: 45, image: img45 },
    { id: 46, image: img46 },
    { id: 47, image: img47 },
    { id: 48, image: img48 },
    { id: 49, image: img49 },
    { id: 50, image: img50 },
    { id: 51, image: img51 },
    { id: 52, image: img52 },
    { id: 53, image: img53 },
    { id: 54, image: img54 },
    { id: 55, image: img55 },
    { id: 56, image: img56 },
    { id: 57, image: img57 },
    { id: 58, image: img58 },
    { id: 59, image: img59 },
    { id: 60, image: img60 },
    { id: 61, image: img61 },
    { id: 62, image: img62 },
    { id: 63, image: img63 },
    { id: 64, image: img64 },
    { id: 65, image: img65 },
    { id: 66, image: img66 },
    { id: 67, image: img67 },
    { id: 68, image: img68 },
    { id: 69, image: img69 },
    { id: 70, image: img70 },
    { id: 71, image: img71 },
    { id: 72, image: img72 },
    { id: 73, image: img73 },
];

export default galleryData;

